// import {render} from "../../vm/render";
// import {renderDom} from "../../vm/render-dom";
import {Exir, jsx} from "../../vm"
import {randomId} from "../../vm/util";
const B = Exir.createView('B', {
    props: {a: 0},
    render() {
        return <b id={this.props.a}>{randomId()}</b>

    }
})
const Fragel = Exir.createView('Fragel', {
    state: {
        count: 1000,
        x: 1,
        items: []
    },
    render() {
        return <div>
            <button id={randomId()} onClick={this.methods.click}>In frag1</button>
            <button id={randomId()} onClick={this.methods.rem}>In frag1</button>
            <h5>Count {this.state.items.length}</h5>
            {this.state.items}
            <p>In frag3 {this.state.x%2===0?(<b>B</b>):(<u>U</u>)}</p>
        </div>
    },
    onCreate() {
        console.log('Fragel created')
    },
    onUpdate() {
        console.log('Fragel updated')
    },
    methods: {
        click() {
            for (let i = 0; i < this.state.count; i++) {
                this.state.items.push(<B a={this.state.x+i}>{randomId()}</B>)
            }
            this.state.x+=this.state.count
            this.$update()
        },
        rem() {
            for (let i = 0; i < this.state.count; i++) {
                this.state.items.pop()
            }
            this.state.x-=this.state.count
            this.$update()
        }
    }
})

global.Fragel = Fragel

global.main = ()=><>
    <h3>Head</h3>
    <Fragel/>
    <Fragel/>
    <div>AAA</div>
</>
console.log(Exir.render(main()))
Exir.mount(main, document.getElementById('root'))
//
// console.log('main', main())
//
// global.mainRender = Exir.render(main())
//
// console.log('render', mainRender)
//
// global.mainDom = Exir.renderDom(mainRender, document.getElementById('root'))
// console.log(mainDom)